<template>
  <b-link class="newsLink" @click="openLink();">
    <div class="mx-3">
      <!--<b-img
        blank
        blank-color="#C8C3C2"
        style="width:100%; height: 150px; border-radius: 1rem;"
      />-->
      <div :style="'width:100%; height: 150px; border-radius: 1rem; background: url(\''+data.image+'\'); background-size: cover; background-position: center;'" />
      <div class="d-flex align-items-center">
        <div
          style="font-weight: bold; font-size: xxx-large; margin-right: 1rem; font-family: 'Poppins', sans-serif;"
        >
          {{ order }}
        </div>
        <div style="font-weight: bold; font-size: small;">
          <span v-html="data.title"></span>
        </div>
      </div>
    </div>
  </b-link>
</template>
<script>
export default {
  props: {
    order: String,
    data: Object
  },
  methods:{
    openLink(){
      if (this.data.internal === "1"){
        this.$router.push("/noticias/detalle/" + this.data.id);
      }else{
        window.open(this.data.url, '_blank');
      }
    }
  }
};
</script>
